import { createUseStyles } from "react-jss";

export default createUseStyles({
    question: {
        borderRadius: 12,
        padding: [[4, 16]],
        margin: [[2, 0]],
        cursor: "pointer",
        fontSize: "13px",

        "&:hover": {
            background: "#F3F3F3",
            color: "black",
        },
    },
    questionSelected: {
        background: "#00A9E8",
        color: "white",

        "&:hover": {
            background: "#00A9E8",
            color: "white",
        },
    },
});
